export default function couponProviderApis($apiInstance, $store) {
    return {
        // Get coupon provider contract list
        getContracts: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            const queryParams = new URLSearchParams();
            // Only send supported params: provider, isActive, companyId
            if (params.provider) {
                queryParams.append('provider', params.provider);
            }
            if (params.isActive !== null && params.isActive !== undefined) {
                queryParams.append('isActive', params.isActive);
            }
            if (params.companyId) {
                queryParams.append('companyId', params.companyId);
            }

            const queryString = queryParams.toString();
            const url = queryString ? `/coupon-provider-contracts?${queryString}` : '/coupon-provider-contracts';

            return $apiInstance.get(url)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Get active contracts for dropdown
        getActiveContracts: async (success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.get('/coupon-provider-contracts/active')
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Get single contract by ID
        getContract: async (id, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.get(`/coupon-provider-contracts/${id}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Create new contract
        createContract: async (data, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.post('/coupon-provider-contracts', data)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Update contract
        updateContract: async (id, data, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.put(`/coupon-provider-contracts/${id}`, data)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Delete contract
        deleteContract: async (id, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.delete(`/coupon-provider-contracts/${id}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Activate contract
        activateContract: async (id, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.patch(`/coupon-provider-contracts/${id}/activate`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Deactivate contract
        deactivateContract: async (id, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.patch(`/coupon-provider-contracts/${id}/deactivate`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Get contractors by provider
        getContractorsByProvider: async (provider, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.get(`/coupon-provider-contracts/providers/${provider}/contractors`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // Get unified products from all active contracts
        getUnifiedProducts: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            const queryParams = new URLSearchParams();
            if (params?.contractId) {
                queryParams.append('contractId', params.contractId);
            }
            if (params?.provider) {
                queryParams.append('provider', params.provider);
            }

            const queryString = queryParams.toString();
            const url = queryString ? `/coupon-provider-contracts/products?${queryString}` : '/coupon-provider-contracts/products';

            return $apiInstance.get(url)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        }
    }
}
